var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d7297429b712f0db2eb964354e7b2856.svg#g';
                    var viewUrl = 'sprites.d7297429b712f0db2eb964354e7b2856.svg#view-g';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '137.718 -1.001 366.563 644',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };